import { memoryStorage } from "./memoryStorage";

export const BLOG_POSTS_STORAGE_KEY = "blackroth_blog_posts";

export const DEFAULT_BLOG_POSTS = [
  {
    id: 1,
    title: "Production Level Blog",
    content: "This is blog content",
    seoTitle: "SEO Title",
    metaDescription: "SEO description",
    imageUrl: "",
    imageUrls: [],
    published: false,
    updatedAt: "2026-03-06",
  },
];

const cloneDefaults = () => DEFAULT_BLOG_POSTS.map((post) => ({ ...post }));

const sanitizePost = (post, index) => ({
  id: post?.id ?? index + 1,
  title: post?.title ?? "",
  content: post?.content ?? "",
  seoTitle: post?.seoTitle ?? "",
  metaDescription: post?.metaDescription ?? "",
  imageUrl: post?.imageUrl ?? "",
  imageUrls: Array.isArray(post?.imageUrls)
    ? post.imageUrls
    : post?.imageUrl
      ? [post.imageUrl]
      : [],
  published: Boolean(post?.published),
  updatedAt: post?.updatedAt ?? "",
});

export const loadBlogPosts = () => {
  try {
    const raw = memoryStorage.getItem(BLOG_POSTS_STORAGE_KEY);
    if (!raw) {
      return cloneDefaults();
    }

    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) {
      return cloneDefaults();
    }

    return parsed.map(sanitizePost);
  } catch (error) {
    return cloneDefaults();
  }
};

export const saveBlogPosts = (posts) => {
  memoryStorage.setItem(BLOG_POSTS_STORAGE_KEY, JSON.stringify(posts));
};
 